module.exports = __webpack_public_path__ + "static/media/pin.87ea9810.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/maps/pin.png
// module id = 1258
// module chunks = 0